import React from 'react'

import {useLocation} from '@reach/router'

import Header from './header'
import Footer from './footer'
import SiteMetadata from '../site-metadata'

const Layout = ({
  title,
  description = '',
  usePrefix = true,
  children,
  className = '',
  fromNotFoundPage = false,
  metaImage = '',
  ...rest
}) => {
  const {pathname} = useLocation()
  return (
    <>
      <SiteMetadata
        pathname={pathname}
        {...(description && {description})}
        title={title}
        usePrefix={usePrefix}
        fromNotFoundPage={fromNotFoundPage}
        metaImage={metaImage}
      />
      <div className={className} {...rest}>
        <Header />
        {children}
        <Footer />
      </div>
    </>
  )
}

export default Layout
